<form id="funcao_form" name="funcao_form" novalidate ng-submit="save(funcao_form)">
  <div class="row">
    <div class="col-xs-12">
      <div class="panel panel-default no-margin">
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label for="descricao">Descrição</label>
                <input class="form-control" ng-model="newFuncao.descricao" type="text" id="descricao" name="descricao" required>
              </div>
            </div>
            <div class="col-xs-12 col-md-4" ng-repeat="item in newFuncao.itens | orderBy:'descricao' track by $index">
              <div class="panel panel-default" style="min-height: 183px;">
                <div class="panel-heading">
                  <h4 class="panel-title">{{item.descricao | capitalize}}</h4>
                </div>

                <div class="list-group">
                  <div class="list-group-item">
                    <div class="row">
                      <div class="col-xs-12 checkbox no-margin" ng-repeat="acao in item.acoes">
                        <label>
                          <input type="checkbox" ng-model="acao.permitir"/>
                          {{acao.descricao}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row pull-right padding-top-10" ng-include="'views/funcoes/_funcao_buttons.html'"></div>
</form>
